import withZendesk from '../../components/HOCs/withZendesk';
import MinimalFooter from '../../components/organisms/footer/MinimalFooter';
import tastify from '@frontastic/catwalk/src/js/helper/tastify';
import React from 'react';
import { compose } from 'redux';

const MinimalFooterTastic = ({ data, context, openChat }) => {
  if (!data) return null;

  const locale = context?.locale === 'en_AU@AUD' ? 'AU' : 'NZ';
  if (!data[`show${locale}`]) return null;

  const { helpText, actions, paymentMethods } = data;
  const className = data.name[context?.locale]

  return (
    <MinimalFooter
      className={className}
      helpText={helpText}
      actions={actions}
      paymentMethods={paymentMethods}
      onOpenChat={openChat}
    />
  );
};

export default compose(
  withZendesk,
  tastify({ translate: true, connect: { context: true } }),
)(MinimalFooterTastic);
